module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-head",
    attrs: {
      "id": "Wel"
    }
  }, [_vm._v("Welcome to Spooky Alabama!")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Alabama is a state with beaches in the south, mountains in the north, and hundreds of years of history in between. Some of the oldest universities in the nation are in Alabama, and so are some of the grandest old houses you’ll ever see. There is art, music, theater, and lots more to love!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Like any place with a long history, Alabama has some dark sides, too. In the antebellum (“pre-war”) years, many thousands of people of color were enslaved here. During the Civil War in the 1860s, people were killed and buildings destroyed. In the years that followed, many people struggled to make sense of the changes they saw after slavery was outlawed: sadly, some even took justice into their own hands, including “lynch mobs” (violent gangs that targeted African Americans) that condemned their victims to death by hanging with no trial, often facing no consequences. It was a frightening, difficult time—you might not be surprised to hear that some of Alabama’s most famous ghost stories stem from these troubled years.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Other stories arose from tales of tragic accidents or lost love. Some took root when illness ran rampant through out the country, death taking loved ones all too quickly. Some legends found homes in abandoned buildings, which just have a way of feeling spooky! There are as many ghost stories as there are stars over Alabama . . . but are they true? Join us for a tour through some of the state’s most haunted places and decide for yourself!")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/P10.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c8f656","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome_to_Spooky_Alabama.vue
// module id = 78
// module chunks = 0